(function() { window.GUID_cc25fbc6_2ad4_492a_8151_a00e8b7f384d = { getGuid: function() { return "cc25fbc6-2ad4-492a-8151-a00e8b7f384d"; } }; })();
var CS;
(function (CS) {
    class DropDownCheckboxes {
        PrepareDataToSend(data) {
            data[this.DropDownCheckboxesId.replace('Container', '')] = this.HiddenValue.val();
        }
        constructor(dropDown) {
            this.SelectionChange = null;
            this.Container = dropDown;
            this.HiddenValue = $('input[type=hidden]', this.Container);
            this.Container.data('context', this);
            this.HiddenValue.data('context', this);
            this.RefreshElementIds = this.HiddenValue.data('refreshelementids').split(',');
            this.RefreshUrl = this.HiddenValue.data('refreshurl');
            if (this.RefreshUrl != null && this.RefreshUrl != "") {
                this.RefreshUrl += CSParameters.SportEventId;
            }
            this.DropDownCheckboxesId = this.Container[0].id;
            this.Prepare();
        }
        val(values) { }
        Prepare() {
            let me = this;
            me.BindToRefreshElements();
            let values = $('.CSDropDownCheckboxesValues', me.Container);
            let checkBoxes = $('.CSDropDownChkItem', values);
            CS.body.off('mouseup.' + me.DropDownCheckboxesId);
            CS.body.on('mouseup.' + me.DropDownCheckboxesId, function (e) {
                if (values.is(':visible')) {
                    values.slideUp(250);
                }
            });
            values.off('CSChange.' + me.DropDownCheckboxesId);
            values.on('CSChange.' + me.DropDownCheckboxesId, function (e) {
                if (me.blockChange) {
                    return;
                }
                let text = '';
                let value = '';
                me.HiddenValue.val('');
                me.replacateCurrentCheckedValues($(e.target), checkBoxes);
                checkBoxes.each(function (i, element) {
                    var checkBox = $('input', element);
                    if (checkBox[0].checked) {
                        var label = $('label', element).text();
                        text += label + ", ";
                        value += checkBox.data('val') + ",";
                    }
                });
                if (text != '') {
                    text = text.substring(0, text.length - 2);
                }
                if (value != '') {
                    me.HiddenValue.val(value.substr(0, value.length - 1));
                }
                let selectedValuesText = $('.SelectedValuesText', me.Container);
                selectedValuesText.text(text);
                me.HiddenValue.trigger('change', me);
            });
            me.Container.off('mouseup.' + me.DropDownCheckboxesId);
            me.Container.on('mouseup.' + me.DropDownCheckboxesId, function (e) {
                e.stopPropagation();
                if (values.is(':visible')) {
                    values.slideUp(250);
                }
                else {
                    values.css('max-height', (CS.body.height() - me.Container.height()) - me.Container.offset().top - 50); //50 est pour clairer la bottom bar de l'interface
                    values.css('min-width', me.Container.width());
                    var otherDropDowns = $('.CSDropDownCheckboxesValues', CS.body);
                    otherDropDowns.slideUp(250);
                    values.slideDown(250);
                }
                //values.toggle();
            });
            values.off('mouseup.' + me.DropDownCheckboxesId);
            values.on('mouseup.' + me.DropDownCheckboxesId, function (e) {
                e.stopPropagation();
            });
        } //Ici, je m'abonne à l'event Change des controles qui servent de filtres
        BindToRefreshElements() {
            var me = this;
            var lastIndex = me.RefreshElementIds.length - 1;
            if (me.RefreshElementIds != null && me.RefreshElementIds[0] != "") {
                $.each(me.RefreshElementIds, function (index, id) {
                    var controller = $('#' + id);
                    if (controller.length == 0) {
                        controller = $('[name="' + id + '"]');
                    }
                    var eventWithNamespace = 'change.' + me.DropDownCheckboxesId;
                    controller.off(eventWithNamespace);
                    controller.on(eventWithNamespace, function () {
                        me.RefreshData();
                    });
                });
            }
        }
        replacateCurrentCheckedValues(currentClickCheckBox, checkBoxes) {
            this.blockChange = true;
            let currentValue = currentClickCheckBox.data('val');
            let currentId = currentClickCheckBox.attr('id');
            let isChecked = currentClickCheckBox.data('context').val();
            let sameIdOtherChBoxes = checkBoxes.filter((i, chkbox) => {
                let $chkBox = $(chkbox).find('input');
                if ($chkBox.attr('id') == currentId) {
                    return false;
                }
                return $chkBox.data('val') == currentValue;
            });
            if (sameIdOtherChBoxes.length > 0) {
                $.each(sameIdOtherChBoxes, function (i, chkbox) {
                    $(chkbox).find('input').data('context').val(isChecked);
                });
            }
            this.blockChange = false;
        }
        ClearSelectedValues() {
            let values = $('.CSDropDownCheckboxesValues', this.Container);
            let checkboxes = $('.CSDropDownChkItem .CSCheckBoxDivChecked', values);
            $.each(checkboxes, function (i, chkbox) {
                $(chkbox).find('input').data('context').val(false);
            });
        }
        RefreshData() {
            var me = this;
            var data = CS.PrepareDataToSendGlobal(me);
            CompuSport.Ajax.Get(me.RefreshUrl, data, function (result) {
                if (result != null) {
                }
            });
        }
    }
    CS.DropDownCheckboxes = DropDownCheckboxes;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSDropDownCheckboxes = function () {
        this.each(function () {
            var DropDownCheckboxes = new CS.DropDownCheckboxes($(this));
            //Donne access au autoComplete de n'importe quels scripts.
            eval('document.' + DropDownCheckboxes.DropDownCheckboxesId + '=DropDownCheckboxes;');
        });
    };
})(jQuery);


var CS = CS || {};

CS.DropDownCheckboxes = function (me) {

    this.SelectionChange = null;
    this.val = function (values) {

    };
    this.Container = me;
    this.HiddenValue = $('input[type=hidden]', this.Container);
    this.RefreshElementIds = this.HiddenValue.data('refreshelementids').split(',');
    this.RefreshUrl = this.HiddenValue.data('refreshurl');
    if (this.RefreshUrl != null && this.RefreshUrl != "") {
        this.RefreshUrl += CSParameters.SportEventId;
    }
    this.DropDownCheckboxesId = this.Container[0].id;
    this.Prepare();
    //return this;
};

CS.DropDownCheckboxes.prototype = function () {

    var Prepare = function () {
        var me = this;

        me.BindToRefreshElements();

        var values = $('.CSDropDownCheckboxesValues', me.Container);
        var checkBoxes = $('.CSDropDownChkItem', values);

        var body = $('body');
        body.off('mouseup.' + me.DropDownCheckboxesId);
        body.on('mouseup.' + me.DropDownCheckboxesId, function (e) {
            if (values.is(':visible')) {
                values.slideUp(250);
            }
        });
        values.off('CSChange.' + me.DropDownCheckboxesId);
        values.on('CSChange.' + me.DropDownCheckboxesId, function () {
            var text = '';
            var value = '';
            me.HiddenValue.val('');
            checkBoxes.each(function (i, element) {
                var checkBox = $('input', element);
                if (checkBox[0].checked) {
                    var label = $('label', element).text();
                    text += label + ", ";
                    value += checkBox.data('val') + ",";
                }
            });
            if (text != '') {
                text = text.substring(0, text.length - 2);
            }
            if (value != '') {
                me.HiddenValue.val(value.substr(0, value.length - 1));
            }
            var selectedValuesText = $('.SelectedValuesText', me.Container);
            selectedValuesText.text(text);
            me.HiddenValue.trigger('change', me);
        });
        me.Container.off('mouseup.' + me.DropDownCheckboxesId);
        me.Container.on('mouseup.' + me.DropDownCheckboxesId, function (e) {
            e.stopPropagation();

            if (values.is(':visible')) {
                values.slideUp(250);
            }
            else {
                values.css('max-height', (body.height() - me.Container.height()) - me.Container.offset().top - 50); //50 est pour clairer la bottom bar de l'interface
                values.css('min-width', me.Container.width());
                var otherDropDowns = $('.CSDropDownCheckboxesValues', body);
                otherDropDowns.slideUp(250);
                values.slideDown(250);
            }


            //values.toggle();
        });
        values.off('mouseup.' + me.DropDownCheckboxesId);
        values.on('mouseup.' + me.DropDownCheckboxesId, function (e) {
            e.stopPropagation();
        });

    }, //Ici, je m'abonne à l'event Change des controles qui servent de filtres
        BindToRefreshElements = function () {
            var me = this;
            var lastIndex = me.RefreshElementIds.length - 1;
            if (me.RefreshElementIds != null && me.RefreshElementIds[0] != "") {
                $.each(me.RefreshElementIds, function (index, id) {

                    var controller = $('#' + id);

                    if (controller.length == 0)
                        controller = $('[name="' + id + '"]');

                    var eventWithNamespace = 'change.' + me.GridViewId;
                    controller.unbind(eventWithNamespace);
                    controller.bind(eventWithNamespace, function () {
                        me.RefreshData();
                    });

                });
            }
        },
        RefreshData = function () {
            var me = this;

            var data = CS.PrepareDataToSendGlobal(me);

            $.ajax({
                cache: false,
                dataType: "json",
                url: me.RefreshUrl,
                data: data,
                success: function (result) {
                    if (result != null) {
                    
                    }
                }
            });

        };

    return {
        Prepare: Prepare,
        BindToRefreshElements: BindToRefreshElements,
        RefreshData: RefreshData
    };

}();
*/ 

//# sourceMappingURL=cs.dropdowncheckboxes.js.map
